export const CLIENT_NOTIFICATION_CENTER_PAGE_SIZE = 20;
export const CLIENT_NOTIFICATION_CENTER_REPORTING_TABLE_ID = "reporting";
export const CLIENT_NOTIFICATION_CENTER_REPORTING_CALENDAR_TABLE_ID =
  "reporting_calendar";
export const CLIENT_NOTIFICATION_CENTER_MESSAGES_TABLE_ID = "messages";
export const CLIENT_NOTIFICATION_CENTER_REGISTRATION_TRACKER_TABLE_ID =
  "registration_tracker";
export const CLIENT_NOTIFICATION_CENTER_THRESHOLDS_TABLE_ID = "thresholds";
export const CLIENT_NOTIFICATION_CENTER_PRODUCT_TABLE_ID = "product";
export const CLIENT_NOTIFICATION_CENTER_BILLING_TABLE_ID = "billing";
export const CLIENT_NOTIFICATION_CENTER_SETTINGS_TABLE_ID = "settings";
export const CLIENT_NOTIFICATION_CENTER_INVOICES_TABLE_ID = "invoices";
export const CLIENT_NOTIFICATION_CENTER_TRANSACTIONS_TABLE_ID = "transactions";
export const CLIENT_NOTIFICATION_CENTER_CONSUMPTION_TABLE_ID = "consumption";

/** Tax (app_id 1) and EPR (app_id 2). */
export const CLIENT_NOTIFICATION_CENTER_TAX_EPR_APP_IDS = [1, 2];
export const CLIENT_NOTIFICATION_CENTER_REPORTING_APP_IDS =
  CLIENT_NOTIFICATION_CENTER_TAX_EPR_APP_IDS;

/** Reporting calendar: Tax, EPR, Marketplace (1 / 2 / 5). */
export const CLIENT_NOTIFICATION_CENTER_REPORTING_CALENDAR_APP_IDS = [1, 2, 5];

/** Thresholds exists only for Tax (app_id 1). */
export const CLIENT_NOTIFICATION_CENTER_THRESHOLDS_APP_IDS = [1];

/** Product exists for Authorize (app_id 6) only. */
export const CLIENT_NOTIFICATION_CENTER_PRODUCT_APP_IDS = [6];

/** Settings: Tax, EPR, Invoice, Marketplace (1 / 2 / 3 / 5). */
export const CLIENT_NOTIFICATION_CENTER_SETTINGS_APP_IDS = [1, 2, 3, 5];

/** Invoices: L'Invoice only (app_id 3). */
export const CLIENT_NOTIFICATION_CENTER_INVOICES_APP_IDS = [3];

/** Transactions: Tax and EPR only (app_id 1 / 2). */
export const CLIENT_NOTIFICATION_CENTER_TRANSACTIONS_APP_IDS = [1, 2];

/** Consumption: Tax, EPR, Invoice and Authorise (app_id 1 / 2 / 3 / 6). */
export const CLIENT_NOTIFICATION_CENTER_CONSUMPTION_APP_IDS = [1, 2, 3, 6];

export function isClientNotificationCenterTaxEprApp(appId) {
  return CLIENT_NOTIFICATION_CENTER_TAX_EPR_APP_IDS.includes(Number(appId));
}

export function isClientNotificationCenterReportingApp(appId) {
  return isClientNotificationCenterTaxEprApp(appId);
}

export function isClientNotificationCenterReportingCalendarApp(appId) {
  return CLIENT_NOTIFICATION_CENTER_REPORTING_CALENDAR_APP_IDS.includes(
    Number(appId)
  );
}

export function isClientNotificationCenterRegistrationTrackerApp(appId) {
  return isClientNotificationCenterTaxEprApp(appId);
}

export function isClientNotificationCenterThresholdsApp(appId) {
  return CLIENT_NOTIFICATION_CENTER_THRESHOLDS_APP_IDS.includes(Number(appId));
}

export function isClientNotificationCenterProductApp(appId) {
  return CLIENT_NOTIFICATION_CENTER_PRODUCT_APP_IDS.includes(Number(appId));
}

export function isClientNotificationCenterSettingsApp(appId) {
  return CLIENT_NOTIFICATION_CENTER_SETTINGS_APP_IDS.includes(Number(appId));
}

export function isClientNotificationCenterInvoicesApp(appId) {
  return CLIENT_NOTIFICATION_CENTER_INVOICES_APP_IDS.includes(Number(appId));
}

export function isClientNotificationCenterTransactionsApp(appId) {
  return CLIENT_NOTIFICATION_CENTER_TRANSACTIONS_APP_IDS.includes(Number(appId));
}

export function isClientNotificationCenterConsumptionApp(appId) {
  return CLIENT_NOTIFICATION_CENTER_CONSUMPTION_APP_IDS.includes(Number(appId));
}
